<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Examination Result Card Report</h5>

    <form class="mr-0" (ngSubmit)="getResultReport()" *ngIf="!exportedFile.file">
      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Cut Off Score</label>
          <input class="form-control" type="number" min="0" [(ngModel)]="resultReport.cutOffScore"
            [ngModelOptions]="{ standalone: true }">
        </div>
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Cut Off Percentage</label>
          <input class="form-control" type="number" min="0" [(ngModel)]="resultReport.cutOffPercentage"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>

      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Sort By</label>
          <ng-select class="form-select" [(ngModel)]="resultReport.sortBy" [ngModelOptions]="{ standalone: true }">
            <ng-option value="" disabled>NotSet</ng-option>
            <ng-option value="CandidateNo">Candidate Number (Ascending)</ng-option>
            <ng-option value="Name">Name (Ascending)</ng-option>
            <ng-option value="Score">"Score (Descending)"</ng-option>
          </ng-select>

        </div>
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Date Of Writing</label>
          <input class="form-control" type="date" [(ngModel)]="resultReport.dateOfWriting"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Candidate Number List</label>
          <textarea class="form-control" rows="2" [(ngModel)]="resultReport.candidateNoList"
            [ngModelOptions]="{ standalone: true }"></textarea>
        </div>
        <div class="mb-3 mr-0 col-md-6">
          <label class="form-label">Human Flags Threshold</label>
          <input class="form-control" type="number" min="0" [(ngModel)]="resultReport.humanFlagsThreshold"
            [ngModelOptions]="{ standalone: true }">
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">Face Mismatch Flags Threshold</label>
          <input class="form-control" type="number" [(ngModel)]="resultReport.faceMismatchFlagsThreshold"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">Multiple Faces Flags Threshold</label>
          <input class="form-control" type="number" [(ngModel)]="resultReport.multipleFacesFlagsThreshold"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">No Face Flags Threshold</label>
          <input class="form-control" type="number" [(ngModel)]="resultReport.noFaceFlagsThreshold"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">Noise Flags Threshold</label>
          <input class="form-control" [(ngModel)]="resultReport.noiseFlagsThreshold" type="number"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">High Score Percentage</label>
          <input class="form-control" [(ngModel)]="resultReport.highScorePercentage" type="number"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <label class="form-label">High Score Percentile</label>
          <input class="form-control" [(ngModel)]="resultReport.highScorePercentile" type="number"
            [ngModelOptions]="{ standalone: true }" min="0" />
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col-md-4">
          <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.skipImportCandidateData"
            [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label ml-1" for="flexCheckDefault">
            Skip Import Candidate Data
          </label>
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.includeMalpracticeSuspicion"
            [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label ml-1" for="flexCheckDefault">
            Include Malpractice Suspicion
          </label>
        </div>
        <div class="mb-3 mr-0 col-md-4">
          <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.writtenOnly"
            [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label ml-1" for="flexCheckDefault">
            Written Only
          </label>
        </div>

      </div>
      <div class="row">
        <div class="mb-3 mr-0 col-md-6">
          <div class="form-check mb-3 mr-0 col-md-12">
            <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.includePassportPhoto"
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label" for="flexCheckDefault">
              Include Passport Photo
            </label>
          </div>

        </div>
        <div class="mb-3 mr-0 col-md-6">
          <div class="form-check mb-3 mr-0 col-md-12">
            <input class="form-check-input" type="checkbox" [(ngModel)]="resultReport.includeContactDetails"
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label" for="flexCheckDefault">
              Include Contact Details
            </label>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-12" type="submit"> Generate Report
      </button>
    </form>
    <app-file-download *ngIf="exportedFile.file" [exportedFile]="exportedFile"></app-file-download>
  </div>
</div>